import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  insuranceData: null,
  benefitsData: [],
  currentPage: 0,
  pageSize: 9,
};

const insuranceSlice = createSlice({
  name: "insurance",
  initialState: initialState,
  reducers: {
    setInsuranceData: (state, action) => {
      state.insuranceData = action.payload.insuranceData;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    setBenefitsData: (state, action) => {
      state.benefitsData = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
  },
});

export const { setInsuranceData, setBenefitsData, setCurrentPage, setPageSize } = insuranceSlice.actions;

export default insuranceSlice.reducer;
